import { FC } from 'react';
import { statusMap } from '@common/constants/statuses';
import { Info } from '@geist-ui/icons';
import { Container } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface StatusBlockProps {
  status: string;
  archived?: boolean;
}

const StatusBlock: FC<StatusBlockProps> = ({ status = 'opened', archived }) => {
  const [t] = useTranslation('reported');
  const currentStatus = archived
    ? statusMap.find((item) => item.value === 'archived')
    : statusMap.find((item) => item.value === status);

  const isMediumDevice = useMediaQuery('(max-width: 992px)');
  const isLargeDevice = useMediaQuery('(max-width: 1200px)');

  return (
    <Container
      m={0}
      py={isMediumDevice ? 12 : 0}
      px={isMediumDevice ? 0 : 20}
      w={isLargeDevice ? 150 : 300}
      className={styles['status-block']}>
      <div className={styles.status} style={{ color: currentStatus?.color }}>
        {currentStatus?.label && t(currentStatus.label)}
      </div>
      <div className={styles.statusInfo}>
        <Info size={20} aria-hidden />
        <span>{currentStatus?.description && t(currentStatus.description)}</span>
      </div>
    </Container>
  );
};

export default StatusBlock;
